import { render } from "./orderPlatform.vue?vue&type=template&id=f3e4b33a&scoped=true"
import script from "./orderPlatform.vue?vue&type=script&lang=js"
export * from "./orderPlatform.vue?vue&type=script&lang=js"

import "./orderPlatform.vue?vue&type=style&index=0&id=f3e4b33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e4b33a"]])

export default __exports__